import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { LOGOS, ICONS } from "../../utils/assets";

import AuthenticatedTemplate from "../../components/AuthenticatedTemplate";
import { Footer } from "../../components/Footer";
import Button from "../../components/form/Button";
import ProgressBar from "../../components/ProgressBar";
import { getLocalDateAndTime } from "../../utils/global";
import { useOrganisationsStore } from "../../stores/organisations-store";

export const Dashboard06ReviewDetails = () => {
  const navigate = useNavigate();
  const { selectedOrganisations, removeOrganisation } = useOrganisationsStore();
  const [orgQuantity] = useState(selectedOrganisations.length || 0);
  const [organisationIDs, setOrganisationIDs] = useState([]);
  const [errors, setErrors] = useState({});
  const [loadingCreateCustomer, setLoadingCreateCustomer] = useState(false);
  const [loadingCreateOrder, setLoadingCreateOrder] = useState(false);
  const gst = 1.15;
  const [customerName, setCustomerName] = useState("");
  const [customerGender, setCustomerGender] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [headerOrder, setHeaderOrder] = useState({});
  const [isNewOrderSaved, setIsNewOrderSaved] = useState(false);
  const [personalDetails, setPersonalDetails] = useState({});
  const [genderDescription] = useState({
    1: "Male",
    2: "Female",
    3: "Other",
  });

  const [customer, setCustomer] = useState({
    Customer_ID: 1,
    Customer_Type: 1,
    Customer_Sub_Type: 0,
    Customer_Email: "",
    Customer_Name: "",
  });

  useEffect(() => {
    const initialize = async () => {
      try {
        await getDataFromLocalStorage();
        await runOrder();
        await fetchCreateNewCustomer();
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };
    initialize();
  }, []);

  const runOrder = async () => {
    try {
      const LS_ORG_QUANT = JSON.parse(
        sessionStorage.getItem("LS_ORGANISATIONS_LIST")
      );
      //Israel updates
      await fetchDataPrice(LS_ORG_QUANT.length);
    } catch (error) {
      console.error("Error running order:", error);
    }
  };

  useEffect(() => {}, [
    customer,
    customerName,
    customerGender,
    customerAddress,
    customerEmail,
    customerPhone,
    organisationIDs,
    orgQuantity,
    headerOrder,
    isNewOrderSaved,
    personalDetails,
  ]);

  async function getDataFromLocalStorage() {
    // Helper function to safely parse sessionStorage items
    const getLocalStorageItem = (key) => {
      try {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error(`Error parsing sessionStorage key "${key}":`, error);
        return null;
      }
    };
    // Retrieve and set personal details
    const details = getLocalStorageItem("LS_DETAILS");
    if (details) {
      const {
        givenNameTo = "",
        middleNameTo = "",
        familyNameTo = "",
        genderToId,
        addressToStr = "",
        emailTo = "",
        mobileNumberTo = "",
      } = details;

      const fullName = `${givenNameTo} ${middleNameTo} ${familyNameTo}`.trim();
      setPersonalDetails(details);
      setCustomerName(fullName);
      setCustomerGender(genderDescription[genderToId] || "");
      setCustomerAddress(addressToStr);
      setCustomerEmail(emailTo);
      setCustomerPhone(mobileNumberTo);
    }
    // Retrieve and set customer info
    const LS_CUSTOMER_INFO = getLocalStorageItem("LS_CUSTOMER_INFO");
    if (LS_CUSTOMER_INFO) {
      const { email = "", fullName = "" } = LS_CUSTOMER_INFO;

      setCustomer({ ...customer, Customer_Email: email });
      setCustomer({ ...customer, Customer_Name: fullName });
    }

    // Retrieve and set organisation IDs
    const LS_ORGANISATIONS_IDS = getLocalStorageItem("LS_ORGANISATIONS_IDS");
    if (LS_ORGANISATIONS_IDS) {
      setOrganisationIDs(LS_ORGANISATIONS_IDS);
    }
    // Retrieve and set order saved state
    const LS_IS_ORDER_SAVED = getLocalStorageItem("LS_IS_ORDER_SAVED");
    if (LS_IS_ORDER_SAVED) {
      setIsNewOrderSaved(LS_IS_ORDER_SAVED === "true");
    }
  }
  /**
   * Helper function to safely update local storage.
   * @param {string} key - The key to store in local storage.
   * @param {any} value - The value to store.
   */
  function updateLocalStorage(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Failed to store ${key} in local storage:`, error.message);
    }
  }

  /**
   * Function to check if the email retrieved from the Token Claim is registered in the database
   */
  async function fetchCreateNewCustomer() {
    setLoadingCreateCustomer(true);
    try {
      const LS_CUSTOMER_INFO = sessionStorage.getItem("LS_CUSTOMER_INFO");
      const { email = "", fullName = "" } = LS_CUSTOMER_INFO
        ? JSON.parse(LS_CUSTOMER_INFO)
        : {};

      const customerObject = {
        Customer_Type: 1,
        Customer_Sub_Type: 0,
        Customer_Email: email,
        Customer_Name: fullName,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/create-customer`,
        {
          customerObject,
        }
      );

      if (response.data?.[0]) {
        const { Customer_ID } = response.data[0];

        sessionStorage.setItem("LS_CUSTOMER_ID", JSON.stringify(Customer_ID));
      } else {
        console.warn("Customer creation response is empty or invalid.");
      }
    } catch (error) {
      console.error(
        "Error while creating customer:",
        error?.response?.data || error.message
      );
    } finally {
      setLoadingCreateCustomer(false);
    }
  }

  const getLocalStorageItem = (key, defaultValue = null) => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(`Error parsing sessionStorage key "${key}":`, error);
      return defaultValue;
    }
  };

  function getSelectedServices() {
    const servicesChecked = getLocalStorageItem("LS_CHECKED_ITEMS", []);
    // Map selected services to a structured object
    //return services.reduce(
    return servicesChecked.reduce(
      (acc, item) => ({
        ...acc,
        [item]: 1,
      }),
      { address: 0, name: 0, gender: 0, emailAddress: 0, mobileNumber: 0 }
    );
  }

  async function populateOrderState(plan, grossAmount, gstAmount) {
    const selectedServices = getSelectedServices();
    const currentDate = getLocalDateAndTime();
    const customerId = getLocalStorageItem("LS_CUSTOMER_ID", 0);
    const customerDetails2 = getLocalStorageItem("LS_DETAILS", []);
    const consentDetails = getLocalStorageItem("LS_CONSENT_DETAILS", {});

    // Construct order headers object
    const orderHeadersObject = {
      Customer_ID: customerId,
      Select_Address: selectedServices.address,
      Select_Name: selectedServices.name,
      Select_Gender: selectedServices.gender,
      Select_Mobile: selectedServices.mobileNumber,
      Select_Email: selectedServices.emailAddress,
      From_Given_Name: customerDetails2.givenNameFrom || "",
      From_Middle_Name: customerDetails2.middleNameFrom || "",
      From_Family_Name: customerDetails2.familyNameFrom || "",
      To_Given_Name: customerDetails2.givenNameTo || "",
      To_Middle_Name: customerDetails2.middleNameTo || "",
      To_Family_Name: customerDetails2.familyNameTo || "",
      From_Gender: customerDetails2.genderFromId,
      To_Gender: customerDetails2.genderToId,
      From_Email: customerDetails2.emailFrom || "",
      To_Email: customerDetails2.emailTo || "",
      From_Mobile_Number: customerDetails2.mobileNumberFrom || "",
      To_Mobile_Number: customerDetails2.mobileNumberTo || "",
      Move_Out_Date: customerDetails2.moveOutDate || "",
      Move_In_Date: customerDetails2.moveInDate || "",
      Requested_Date: currentDate,
      Order_Status: 1,
      Quantity_Organisations: parseInt(orgQuantity),
      Net_Amount: plan || 0,
      GST_Percentage: 15,
      GST_Amount: gstAmount || 0,
      Gross_Amount: grossAmount || 0,
      Payment_Type: 1,
      Payment_Status: 1,
      ...mapAddressDetails("From", customerDetails2.addressFromArray),
      ...mapAddressDetails("To", customerDetails2.addressToArray),
      Consent_Given: consentDetails.given,
      Consent_Version: consentDetails.version,
      Consent_Content: consentDetails.content,
      Customer_Name: JSON.parse(sessionStorage.getItem("LS_CUSTOMER_INFO"))
        ?.fullName,
      Email: JSON.parse(sessionStorage.getItem("LS_CUSTOMER_INFO"))?.email,
      Attached_File:
        customerDetails2.documents?.length > 0
          ? customerDetails2.documents.join(";")
          : "",
    };
    setHeaderOrder(orderHeadersObject);
  }

  // Helper function to map address details
  const mapAddressDetails = (prefix, addressArray = {}) => ({
    [`${prefix}_Address_Building_Name`]:
      addressArray.Local_Address_Building_Name || "",
    [`${prefix}_Address_Unit_Number`]:
      addressArray.Local_Address_Unit_Number || "",
    [`${prefix}_Address_Street_Number`]:
      addressArray.Local_Address_Street_Number || "",
    [`${prefix}_Address_Street_Name`]:
      addressArray.Local_Address_Street_Name || "",
    [`${prefix}_Address_Suburb`]: addressArray.Local_Address_Suburb || "",
    [`${prefix}_Address_City`]: addressArray.Local_Address_City || "",
    [`${prefix}_Address_State_Region`]:
      addressArray.Local_Address_State_Region || "",
    [`${prefix}_Address_Country`]: addressArray.Local_Address_Country || "",
    [`${prefix}_Address_Post_Code`]: addressArray.Local_Address_Post_Code || "",
  });
  /**
   * Function to get data from Price table
   * > price.control exports > getPrices
   */
  async function fetchDataPrice(quantOrg) {
    try {
      // Get current date in ISO format
      const currentDate = getLocalDateAndTime();
      // Make POST request to fetch prices
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/finances/get-prices`,
        {
          currentDate,
          quantOrg,
        }
      );

      const priceData = response.data;
      if (priceData) {
        const { Price_Amount } = priceData;
        await calculateRates(Price_Amount);
      } else {
        console.warn("No price data received.");
      }
    } catch (error) {
      console.error(
        "Error fetching data price:",
        error.response?.data || error.message
      );
    }
  }
  /**
   * Function to calculate GST, Total Payable and Store values in Local Storage
   */
  async function calculateRates(planPrice) {
    try {
      // Validate and use the current plan price
      const plan = parseFloat(planPrice);

      if (isNaN(plan) || plan < 0) {
        console.warn("Invalid plan price. Calculation skipped.");
        return;
      }

      // Store plan price in local storage
      updateLocalStorage("LS_PRICE_PLAN_PRICE", plan);

      // Calculate gross amount and GST
      const grossAmount = parseFloat((plan * gst).toFixed(2));
      const gstAmount = parseFloat((grossAmount - plan).toFixed(2));

      // Store calculated values in local storage
      updateLocalStorage("LS_PRICE_PAYABLE", grossAmount);
      updateLocalStorage("LS_PRICE_GST_INCLUDED", gstAmount);

      // Perform subsequent asynchronous operations
      await fetchCreateNewCustomer();
      await populateOrderState(plan, grossAmount, gstAmount);
    } catch (error) {
      console.error("Error during rate calculation:", error.message);
    }
  }

  /**
   * Function to insert data into the Order_Headers table
   * > order.control exports > createNewOrder
   */
  async function fetchInsertNewOrder() {
    setLoadingCreateOrder(true);
    const orderId = JSON.parse(localStorage.getItem("LS_ORDER_ID"));
    const organisations = JSON.parse(
      localStorage.getItem("LS_ORGANISATIONS_LIST")
    );

    if (orderId !== null && orderId !== undefined && orderId !== "") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/orders/update-order`,
          {
            orderObject: headerOrder,
            ORDER_ID: orderId,
          }
        );

        const orderData = response.data;
        if (orderData?.message) {
          // Update state and local storage
          setIsNewOrderSaved(true);
          updateLocalStorage("LS_ORDER_ID", orderId);
          updateLocalStorage("LS_IS_ORDER_SAVED", "true");

          localStorage.setItem("LS_ORDER_ID", orderId);
        } else {
          console.warn("No order data returned from the server.");
        }
      } catch (error) {
        console.error(
          "Error creating order:",
          error.response?.data || error.message
        );
      }
      setLoadingCreateOrder(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/orders/create-order`,
          {
            orderObject: headerOrder,
          }
        );

        const orderData = response.data;
        if (orderData?.orderId) {
          // Update state and local storage
          setIsNewOrderSaved(true);
          updateLocalStorage("LS_ORDER_ID", orderData.orderId);
          updateLocalStorage("LS_IS_ORDER_SAVED", "true");
          localStorage.setItem("LS_ORDER_ID", orderData.orderId);
          localStorage.setItem(
            "LS_ORGANISATIONS_LIST",
            JSON.stringify(organisations)
          );
        } else {
          console.warn("No order data returned from the server.");
        }
      } catch (error) {
        console.error(
          "Error creating order:",
          error.response?.data || error.message
        );
      } finally {
        setLoadingCreateOrder(false);
      }
    }
  }

  /**
   * Function to remove Organisation object by index.
   * @param {string | number} orgId - The ID of the organisation to remove.
   */
  const handleRemoveItem = async (orgId) => {
    removeOrganisation(orgId);
    await runOrder();
  };

  const validateFields = () => {
    let isValid = true;
    let newErrors = {};

    if (!selectedOrganisations.length) {
      newErrors["selectedOrganisations"] =
        "Please select at least one organisation.";
      isValid = false;
    }

    const customerDetails = sessionStorage.getItem("LS_DETAILS");
    if (!customerDetails) {
      newErrors["customerDetails"] = "Please fill out your details.";
      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  const handleBack = () => {
    const allAccountLabelsNull = selectedOrganisations.every(
      (item) => !item.Organisation_Account_Label
    );

    if (allAccountLabelsNull) {
      navigate("/dashboard-organisations");
    } else {
      navigate("/dashboard-organisations-details");
    }
  };

  const handleContinue = async () => {
    const isValid = validateFields();

    if (!isValid) return;

    await fetchInsertNewOrder();

    navigate("/dashboard-checkout");
  };

  return (
    <>
      <AuthenticatedTemplate>
        <section className="step__container">
          <div className="step__content">
            <div className="review-details">
              <div className="step__header">
                <img
                  className="logo"
                  src={LOGOS.QUICKMOVE_FLOW}
                  alt="Quickmove logo"
                />
                <h1 className="text-md text-md--variant">
                  Review your Details
                </h1>
              </div>

              <ProgressBar percentage="70" />

              <div className="selected-organisations">
                <h2 className="paragraph-md semibold paragraph-md--dark">
                  Selected Organisation
                </h2>

                {selectedOrganisations
                  ? selectedOrganisations.map((item, index) => {
                      return (
                        <div
                          key={item.Organisation_Account_ID + index}
                          className="selected-organisations__item"
                        >
                          <div className="selected-organisations__info">
                            <div className="logo-box">
                              <img
                                className="logo-box__image"
                                src={item.Organisation_Logo_Path}
                                alt={"Organisation logo"}
                              />
                            </div>
                            <div className="selected-organisations__text">
                              <h3 className="paragraph-md semibold paragraph-md--dark">
                                {item.Organisation_Name}
                              </h3>
                              {item.Organisation_Account_Label && (
                                <h3 className="small">
                                  {item.Organisation_Account_Label +
                                    ": " +
                                    item.Organisation_Account_ID}
                                </h3>
                              )}
                            </div>
                          </div>
                          <button
                            className="button button--compact button--danger"
                            onClick={() =>
                              handleRemoveItem(item.Organisation_ID)
                            }
                          >
                            Delete
                          </button>
                        </div>
                      );
                    })
                  : null}

                <p className="paragraph-md">
                  Forgot a supplier? Not a problem!&nbsp;{" "}
                  <Link
                    to="/dashboard-organisations"
                    className="paragraph-md paragraph-md--dark semibold"
                  >
                    Add more here &gt;
                  </Link>
                </p>

                {errors.selectedOrganisations && (
                  <p className="paragraph-md text-danger">
                    {errors.selectedOrganisations}
                  </p>
                )}
              </div>

              <div className="review-customer">
                <div className="review-customer__header">
                  <h2 className="paragraph-md semibold paragraph-md--dark">
                    Customer
                  </h2>
                </div>
                <ul className="review-customer__info">
                  {customerName ? (
                    <li className="review-customer__item">
                      <img src={ICONS.USER_ICON} alt="User icon" />
                      <div>
                        <h3 className="paragraph-md semibold paragraph-md--dark">
                          Name
                        </h3>
                        <p className="paragraph-md"> {customerName}</p>
                      </div>
                    </li>
                  ) : null}
                  {customerGender ? (
                    <li className="review-customer__item">
                      <img src={ICONS.GENDER_ICON} alt="Gender icon" />
                      <div>
                        <h3 className="paragraph-md semibold paragraph-md--dark">
                          Gender
                        </h3>
                        <p className="paragraph-md">{customerGender}</p>
                      </div>
                    </li>
                  ) : null}
                  {customerAddress ? (
                    <li className="review-customer__item">
                      <img src={ICONS.ADDRESS_ICON} alt="Address icon" />
                      <div>
                        <h3 className="paragraph-md semibold paragraph-md--dark">
                          Address
                        </h3>
                        <p className="paragraph-md">{customerAddress}</p>
                      </div>
                    </li>
                  ) : null}
                  {customerEmail ? (
                    <li className="review-customer__item">
                      <img src={ICONS.EMAIL_ICON} alt="E-mail icon" />
                      <div>
                        <h3 className="paragraph-md semibold paragraph-md--dark">
                          E-mail
                        </h3>
                        <p className="paragraph-md">{customerEmail}</p>
                      </div>
                    </li>
                  ) : null}
                  {customerPhone ? (
                    <li className="review-customer__item">
                      <img src={ICONS.PHONE_ICON} alt="Phone icon" />
                      <div>
                        <h3 className="paragraph-md semibold paragraph-md--dark">
                          Phone
                        </h3>
                        <p className="paragraph-md">{customerPhone}</p>
                      </div>
                    </li>
                  ) : null}
                </ul>

                {errors.customerDetails && (
                  <p className="paragraph-md text-danger">
                    {errors.customerDetails}
                  </p>
                )}
              </div>

              <div className="action-buttons">
                <Button className="outlined" onClick={() => handleBack()}>
                  Back
                </Button>
                <Button
                  variant="primary"
                  icon={ICONS.CARET_ICON}
                  iconAlt="Caret icon"
                  loading={loadingCreateCustomer || loadingCreateOrder}
                  onClick={() => handleContinue()}
                >
                  Continue
                </Button>
              </div>

              <Footer />
            </div>
          </div>
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
